export interface UploadTicket {
    fileId: string;
    uploadUrl: string;
    headers: Record<string, string>;
}

export interface PutOptions {
    onProgress?: (fraction: number) => void;
    /** Called with a function that, when invoked, aborts the in-flight XHR. */
    onRegisterAbort?: (abort: () => void) => void;
}

export function putBlobToSignedUrl(
    ticket: UploadTicket,
    blob: Blob,
    opts: PutOptions = {}
): Promise<void> {
    // Bare XHR for byte-level progress and no bearer token (GCS signed URLs reject it);
    // ticket.headers sets the Content-Type the V4 signature is bound to.
    return new Promise<void>((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        opts.onRegisterAbort?.(() => xhr.abort());

        xhr.upload.onprogress = (event) => {
            if (!opts.onProgress) return;
            const fraction = event.lengthComputable ? Math.min(event.loaded / event.total, 1) : -1;
            if (fraction >= 0) opts.onProgress(fraction);
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve();
            } else {
                reject(new Error(`Upload to storage failed (${xhr.status})`));
            }
        };

        xhr.onerror = () => reject(new Error('Upload to storage failed (network error)'));
        xhr.onabort = () => reject(new Error('Upload cancelled'));

        xhr.open('PUT', ticket.uploadUrl);
        Object.entries(ticket.headers).forEach(([key, value]) => xhr.setRequestHeader(key, value));
        xhr.send(blob);
    });
}
